<div class="side">
  <nav aria-label="Administrasjon">
    <button mat-button type="button" [class.aktiv]="aktiv() === 'soek'" (click)="gaaTil('soek')">{{ 'Søk' | translate }}</button>
    <button mat-button type="button" [class.aktiv]="aktiv() === 'avtaler'" (click)="gaaTil('avtaler')">{{ 'Avtaler' | translate }}</button>
    <button mat-button type="button" [class.aktiv]="aktiv() === 'brukere'" (click)="gaaTil('brukere')">{{ 'Brukere' | translate }}</button>
    <button mat-button type="button" [class.aktiv]="aktiv() === 'meldinger'" (click)="gaaTil('meldinger')">{{ 'Meldinger' | translate }}</button>
    <button mat-button type="button" [class.aktiv]="aktiv() === 'asynkOppgaver'" (click)="gaaTil('asynkOppgaver')">{{ 'Jobber' | translate }}</button>
    <button mat-button type="button" [class.aktiv]="aktiv() === 'spoerreskjemaer'" (click)="gaaTil('spoerreskjemaer')">{{ 'Spørreskjemaer' | translate }}</button>
</nav>
  <ng-content></ng-content>
</div>
